import {
  defaultProductOrderMaterialLotDto,
  ProductOrderMaterialLotDto,
} from "src/dtos/prdOrderMaterialLot/ProductOrderMaterialLotDto";
import {
  defaultProductOrderDto,
  ProductOrderDto,
} from "src/dtos/productOrder/ProductOrderDto";

/** 상단 작업지시 그리드에서 사용하는 화면 DTO이다. */
export interface PRD2050_R01Dto extends ProductOrderDto {}

/** 빈 행 렌더링과 Store 목록 정규화에 사용하는 작업지시 기본값이다. */
export const defaultPRD2050_R01Dto: PRD2050_R01Dto = {
  ...defaultProductOrderDto,
};

/**
 * 하단 상세와 LOT 선택 모달에서 사용하는 화면 DTO이다.
 * 등록 엔티티 필드에 재고·품목·창고 조회 결과를 화면 표시용으로 확장한다.
 */
export interface PRD2050_R01LotDto extends ProductOrderMaterialLotDto {
  logicCenter: string;
  warehouseCd: string;
  warehouseNm: string;
  itemNm: string;
  itemSpec: string;
  itemUnit: string;
  itemStatus: string;
  /** 상세 그리드 참조용 LOT의 현재 잔여 재고량이다. (저장하지 않는다.) */
  stockQty: number;
}

/** 빈 행 렌더링과 Store 목록 정규화에 사용하는 LOT 기본값이다. */
export const defaultPRD2050_R01LotDto: PRD2050_R01LotDto = {
  ...defaultProductOrderMaterialLotDto,
  logicCenter: "",
  warehouseCd: "",
  warehouseNm: "",
  itemNm: "",
  itemSpec: "",
  itemUnit: "",
  itemStatus: "",
  stockQty: 0,
};
